module.exports = __webpack_public_path__ + "static/media/sraa.12e5ea3f.md";